import state from './error.state'
import mutations from './error.mutations'
import actions from './error.actions'
import getters from './error.getters'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



//////////////////
// WEBPACK FOOTER
// ./state/error/error.module.js
// module id = null
// module chunks = 